module.exports = __webpack_public_path__ + "static/media/mode-7.41a4145e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-7.svg
// module id = 962
// module chunks = 2